<script setup>
import {computed} from 'vue'

import PageEditorContentPanel from "./PageEditorContentPanel.vue"
import PageEditorContentAreaPanel from "./PageEditorContentAreaPanel.vue"
import PageEditorPagePanel from "./PageEditorPagePanel.vue"
import PageEditorSectionPanel from "./PageEditorSectionPanel.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const pageId = computed(() => pageEditorStore.pageId)
const activeSectionId = computed(() => pageEditorStore.activeSectionId)
const activeContentAreaName = computed(() => pageEditorStore.activeContentAreaName)
const activePageContentId = computed(() => pageEditorStore.activePageContentId)
const pagePanelActiveTab = computed(() => pageEditorStore.pagePanelActiveTab)
const contentPanelActiveTab = computed(() => pageEditorStore.contentPanelActiveTab)

const isOpen = computed(() => {
    if (activeContentAreaName.value) {
        return true
    } else if (activePageContentId.value) {
        return !!contentPanelActiveTab.value
    } else {
        return !!pagePanelActiveTab.value
    }
})
</script>

<template>
    <aside class="overflow-y-scroll" :class="{'open border-start': isOpen, 'closed': !isOpen}">
        <PageEditorSectionPanel v-if="activeSectionId" :key="activeSectionId"/>
        <PageEditorContentAreaPanel v-else-if="activeContentAreaName"/>
        <PageEditorContentPanel v-else-if="activePageContentId" :key="activePageContentId"/>
        <PageEditorPagePanel v-else :key="pageId"/>
    </aside>
</template>

<style scoped>
.closed {
    flex: 0 0 32px
}

.open {
    flex: 0 0 260px
}
</style>